module.exports = __webpack_public_path__ + "images/1b3db26166f086e8386aa3f46d621ac9.svg";